export default "__VITE_ASSET__4EH5JCRb__"